/**
 * Product Sticky Bar
 * Mobile add-to-cart bar shown once the main buy buttons have scrolled above the viewport.
 * Its button submits the main Dawn product form (form="product-form-…"), so both buttons share one add path.
 */

(function () {
  'use strict';

  function initStickyBar() {
    const stickyBar = document.querySelector('.product__sticky-bar');
    const buyButtons = document.querySelector('.product__buy-buttons');
    if (!stickyBar || !buyButtons) return;

    const mobile = window.matchMedia('(max-width: 749px)');
    let scrolledPast = false;

    const update = () => {
      const visible = mobile.matches && scrolledPast;
      stickyBar.classList.toggle('product__sticky-bar--visible', visible);
      document.body.classList.toggle('sticky-bar-visible', visible);
    };

    new IntersectionObserver(
      ([entry]) => {
        scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < (entry.rootBounds?.top ?? 0);
        update();
      },
      { threshold: 0, rootMargin: '-80px 0px 0px 0px' }
    ).observe(buyButtons);
    mobile.addEventListener('change', update);

    // Mirror the main button while a variant loads, then take price and availability from the re-rendered section.
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => {
      const button = stickyBar.querySelector('button');
      if (button) button.disabled = true;
    });
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const content = stickyBar.querySelector('.product__sticky-bar-content');
      const updated = data.html.getElementById(stickyBar.id)?.querySelector('.product__sticky-bar-content');
      if (content && updated) content.innerHTML = updated.innerHTML;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBar);
  } else {
    initStickyBar();
  }
})();
